import {ClickEvent} from "../../../infrastructure/models/analytics/click-event";
import {Type} from "../../../infrastructure/type";
import {EntityViewModel} from "../../../infrastructure/models/entity/entity.view-model";

export class TopStatsClickEvent extends ClickEvent {
  entityType: Type<EntityViewModel>;
  entityId: Number;
  sportTypeId: Number;

  constructor(params) {
    super('', 'click', 'top-stats');

    this.entityType = params.entityType;
    this.entityId = params.entityId;
    this.sportTypeId = params.sportTypeId;
  }

  get properties() {
    const properties = super.properties;

    properties.entityType = this.entityType;
    properties.entityId = this.entityId;
    properties.sportTypeId = this.sportTypeId;

    return properties;
  }
}